import React, { useState, useEffect } from "react";
import axios from "axios";
import SectionLandingLikePublications from "../common/SectionLandingLikePublications";

export default function SustainableFinance() {
  const [post, setPost] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get("/sustainablefinance")
      .then((response) => {
        const data = response.data;
        if (!cancelled) {
          setPost(Array.isArray(data) ? data : data ? [data] : []);
        }
      })
      .catch(() => {
        if (!cancelled) setPost([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const lead = (
    <>
      <p>
        As a central bank, we are committed to fostering economic stability and sustainability. We prioritize
        initiatives that integrate sustainable finance practices into our operations.
      </p>
      <p>
        We develop strategies to address climate-related risks, strengthen governance, and implement regulatory
        frameworks that support sustainable financial practices. Browse the section below for related topics.
      </p>
    </>
  );

  return (
    <SectionLandingLikePublications
      breadcrumbCurrent="Sustainable Finance"
      headingId="sustainable-finance-bnr-heading"
      pageTitle="Sustainable Finance"
      tagline="Stability, sustainability and responsible finance"
      sharePageTitle="Sustainable Finance — National Bank of Rwanda"
      lead={lead}
      posts={post}
      pageFeedbackPath="/sustainablefinance"
      isLoading={isLoading}
    />
  );
}
